<div class="no-data-container" [ngClass]="size">
    <mat-icon class="no-data-icon">{{ icon }}</mat-icon>
    <p class="no-data-message">{{ message | translate }}</p>
    <p class="no-data-description" *ngIf="description">{{ description | translate }}</p>

    <div class="no-data-actions">
        <ng-content></ng-content>
    </div>
</div>